import React from "react"
const CancelPayment = () => {
    return (
        <>
        </>
    );
}

export default CancelPayment;